import Phaser from 'phaser';
import { useGameStore } from '../store/gameStore';

export class GameOverScene extends Phaser.Scene {
  private score: number = 0;
  private isMobile: boolean = false;
  private resizeHandler?: () => void;
  private phaserElements: Phaser.GameObjects.GameObject[] = [];

  constructor() {
    super({ key: 'GameOverScene' });
  }

  init(data: { score: number }) {
    this.score = data.score || 0;
  }

  create() {
    this.isMobile = (window as any).isMobileDevice || false;
    this.cleanupPhaserElements();

    // 화면 방향 전환 이벤트 리스너
    this.resizeHandler = () => this.handleResize();
    window.addEventListener('resize', this.resizeHandler);
    window.addEventListener('orientationchange', this.resizeHandler);

    this.createUI();
  }

  private handleResize(): void {
    setTimeout(() => {
      this.cleanupPhaserElements();
      this.createUI();
    }, 100);
  }

  private createUI(): void {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const isLandscape = width > height;

    // 배경 (반투명 검정)
    const bg = this.add.rectangle(width / 2, height / 2, width * 2, height * 2, 0x000000, 0.7);
    bg.setScrollFactor(0);
    this.phaserElements.push(bg);

    // 폰트 크기 계산
    const titleFontSize = this.isMobile
      ? (isLandscape ? '40px' : '36px')
      : '64px';
    const scoreFontSize = this.isMobile
      ? (isLandscape ? '22px' : '20px')
      : '32px';
    const hintFontSize = this.isMobile
      ? (isLandscape ? '16px' : '14px')
      : '24px';

    // 위치 계산
    const centerY = height / 2;
    const titleOffset = this.isMobile ? 40 : 50;
    const scoreOffset = this.isMobile ? 15 : 20;
    const hintOffset = this.isMobile ? 70 : 100;

    // Game Over 텍스트
    const gameOverText = this.add.text(width / 2, centerY - titleOffset, 'GAME OVER', {
      fontSize: titleFontSize,
      color: '#FF4757',
      fontFamily: 'Nunito',
      fontStyle: 'bold'
    }).setOrigin(0.5).setScrollFactor(0);
    this.phaserElements.push(gameOverText);

    // 점수 표시
    const scoreText = this.add.text(width / 2, centerY + scoreOffset, `Final Score: ${this.score}`, {
      fontSize: scoreFontSize,
      color: '#FFFFFF',
      fontFamily: 'Nunito'
    }).setOrigin(0.5).setScrollFactor(0);
    this.phaserElements.push(scoreText);

    // 재시작 안내
    const restartHint = this.isMobile ? 'Tap to Restart' : 'Click to Restart';
    const hintText = this.add.text(width / 2, centerY + hintOffset, restartHint, {
      fontSize: hintFontSize,
      color: '#4D96FF',
      fontFamily: 'Nunito'
    }).setOrigin(0.5).setScrollFactor(0);
    this.phaserElements.push(hintText);

    // 깜빡임 효과
    this.tweens.add({
      targets: hintText,
      alpha: 0.5,
      duration: 800,
      yoyo: true,
      repeat: -1,
    });

    this.input.on('pointerdown', () => {
      this.cleanup();
      useGameStore.getState().resetGame();
      this.scene.start('GameScene');
    });
  }

  private cleanupPhaserElements(): void {
    for (const element of this.phaserElements) {
      if (element && element.scene) {
        element.destroy();
      }
    }
    this.phaserElements = [];
  }

  private cleanup(): void {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
      window.removeEventListener('orientationchange', this.resizeHandler);
    }
    this.cleanupPhaserElements();
  }

  shutdown() {
    this.cleanup();
  }
}
